<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="labelSelect"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="false"
    :disabled="isDisabled"
    placeholder=""
    :show-labels="false"
    :option-height="58"
    track-by="path"
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>

    <template slot="option" slot-scope="props">
      <div class="option__desc">
        <span class="font-weight-bold d-block">{{ props.option.nome }}</span>
        <span class="small font-weight-light">{{ props.option.path }}</span>
      </div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['isDisabled', 'emptyLabel', 'data'],

  data() {
    return {
      selected: '',
      options: []
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);

      if (e == null) {
        this.$emit('selectChange', 'search', null);
        return;
      }
      this.$emit('selectChange', 'search', e.path);

      this.$emit('focus');

      this.selected = '';
    },

    labelSelect({ nome, path }) {
      return `${nome} - ${path}`;
    },

    setOptions(data) {
      if (this.data || data) {
        this.options = this.options.concat(this.data || data);
      }
    }
  },
  created() {
    this.setOptions(this.data);
  },
  watch: {
    data: function (value) {
      if (value.length > 0) {
        this.setOptions(this.data);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
